import createStyles from '@guestyci/foundation/createStyles';
import defaultTheme from '@guestyci/foundation/theme/defaultTheme';
import typography from '@guestyci/foundation/theme/typography';

const useCustomTextFieldStyles = createStyles((theme: typeof defaultTheme) => ({
  h1: {
    ...typography.h1,
    color: theme.palette.text.dark,
  },
  h2: {
    ...(typography as unknown as { h2: Record<string, any> }).h2,
    color: theme.palette.text.dark,
  },
  h3: {
    ...(typography as unknown as { h3: Record<string, any> }).h3,
    color: theme.palette.text.dark,
  },
  smallText: {
    color: theme.palette.text.default,
  },
  darkenBoldSmallText: {
    fontWeight: theme.typography.fontWeight.bold,
    fontSize: theme.typography.fontSize.h5,
    fontStyle: theme.typography.fontStyle.normal,
    color: theme.palette.text.default,
  },
  whiteBoldSmallText: {
    fontWeight: theme.typography.fontWeight.bold,
    fontSize: theme.typography.fontSize.h5,
    fontStyle: theme.typography.fontStyle.normal,
    color: theme.palette.text.white,
  },
  link: {
    color: theme.palette.success.default,
  },
}));

export default useCustomTextFieldStyles;
